import Scrollbars from "./custom";
export default Scrollbars;
